import { CDropdownMenu } from "@coreui/react";
import { createPortal } from "react-dom";
import "./list-actions-menu.scss";

const ListActionsMenu: React.FC = ({ children }) =>
  // Keep the menu outside the table's scroll container while retaining the
  // dropdown context for positioning, outside clicks and Escape handling.
  createPortal(
    <CDropdownMenu
      placement="bottom-end"
      modifiers={[
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            padding: 8,
            altAxis: true,
          },
        },
      ]}
      style={{
        maxHeight: "calc(100vh - 16px)",
        minWidth: "min(10rem, calc(100vw - 16px))",
        maxWidth: "calc(100vw - 16px)",
        overflowY: "auto",
      }}
      className="list-actions-menu"
    >
      {children}
    </CDropdownMenu>,
    document.body,
  );

export default ListActionsMenu;
